import { DownOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";

const DashBoardFilters = ({
  typeMenu,
  setTypeMenuOpen,
  typeMenuOpen,
  selectedTypeLabel,
  cycleDropdownRef,
  cycleMenuOpen,
  setCycleMenuOpen,
  selectedCycleLabel,
  detailsData,
  selectedCycleIds,
  setSelectedCycleIds,
}) => {
  return (
    <div className="dashFilterBar">
      <div className="dashFilterBar-inner">
        <div className="filterGroup">
          <span className="filterLabel">Audit Type: </span>
          <Dropdown
            overlay={typeMenu}
            trigger={["click"]}
            onOpenChange={setTypeMenuOpen}
          >
            <div
              className={`filterPill gap-2 ${typeMenuOpen ? "bg-active" : "bg-inactive"}`}
              onClick={(e) => e.preventDefault()}
            >
              <p>{selectedTypeLabel || "Select type"}</p>
              <DownOutlined />
            </div>
          </Dropdown>
        </div>

        <div className="filterDivider" />

        <div
          className="filterGroup"
          style={{ position: "relative" }}
          ref={cycleDropdownRef}
        >
          <span className="filterLabel">Audit Cycle: </span>

          <div
            className={`filterPill gap-2 ${cycleMenuOpen ? "bg-active" : "bg-inactive"}`}
            onClick={() => setCycleMenuOpen((prev) => !prev)}
          >
            <p
              style={{
                margin: 0,
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={selectedCycleLabel}
            >
              {selectedCycleLabel || "Select Type of Audit"}
            </p>
            <DownOutlined style={{ flexShrink: 0 }} />
          </div>

          {cycleMenuOpen && (
            <div
              className="custom-cycle-dropdown"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                marginTop: 4,
                zIndex: 1000,
                background: "#fff",
                border: "1px solid #eee",
                borderRadius: 6,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                minWidth: 240,
                maxWidth: 300,
                maxHeight: 280,
                overflowY: "auto",
                padding: "4px 0",
              }}
            >
              <div
                style={{
                  padding: "6px 12px",
                  fontSize: 12,
                  color: "#888",
                }}
              >
                Select up to 5 audits
              </div>

              {detailsData?.map((item) => {
                const isSelected = selectedCycleIds.includes(item.id);
                const isDisabled = !isSelected && selectedCycleIds.length >= 5;

                return (
                  <div
                    key={item.id}
                    onClick={() => {
                      if (isDisabled) return;

                      setSelectedCycleIds((prev) => {
                        // Minimum 1 cycle must always remain selected
                        if (prev.includes(item.id) && prev.length === 1) {
                          return prev;
                        }

                        return prev.includes(item.id)
                          ? prev.filter((id) => id !== item.id)
                          : [...prev, item.id];
                      });
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "6px 12px",
                      cursor:
                        isDisabled ||
                        (isSelected && selectedCycleIds.length === 1)
                          ? "not-allowed"
                          : "pointer",
                      opacity:
                        isDisabled ||
                        (isSelected && selectedCycleIds.length === 1)
                          ? 0.5
                          : 1,
                    }}
                  >
                    <input type="checkbox" checked={isSelected} readOnly />
                    <span>{item.name}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashBoardFilters;
